import type {IStage} from '../interfaces/IStage';

// const PluriAerienMai2025: IStage = {
//   name: 'Stage mai 2025',
//   title: 'Stage de cirque pluridisciplinaire et aérien',
//   short_title: 'Stage de cirque et aérien',
//   date: 'Du 5 au 9 mai 2025 de 9h00 à 16h00',
//   accroche: "Envolons-nous vers l'aventure avec notre Stage de Cirque et Aérien pour enfants ! ",
//   texte: "Ce stage proposera une découverte des différentes disciplines de cirque le matin et l'après-midi sera consacré à une initiation à l'aérien  (trapèze, tissu, cerceau). Ce stage n'est pas une spécialisation pour des élèves ayant déjà pratiqué l'aérien. Ils sont néanmoins les bienvenus et des exercices leur seront proposés en fonction de leur niveau. Celui-ci est destiné aux enfants à partir de 6 ans qui désirent découvrir le monde du cirque et des joies de se mettre la tête en bas pour la première fois. Les enfants auront l'opportunité de développer leur agilité, leur créativité et leur confiance en soi tout en s'amusant ! En plus de développer des compétences physiques, nos stages encouragent également le travail d'équipe, la concentration et la discipline, des valeurs essentielles pour la vie quotidienne.",
//   qui: "Pour les enfants de 6 ans à 15 ans.",
//   prix: 115,
//   statut: 'confirmed',
//   prix_detail: '- 10% si famille nombreuse ou 2ème enfant inscrit de la même famille',
//   img: "/images/stages/stage_mai.jpg",
//   isCancelled: true
// };


// const AerienJuillet2025: IStage = {
//   name: 'Stage 1 juillet 2025',
//   title: 'Stage de cirque et aérien',
//   short_title: 'Stage de cirque et aérien',
//   date: 'Du 7 au 11 juillet 2025 de 9h à 16h',
//   accroche: "Envolons-nous vers l'aventure avec notre stage !",
//   texte: "Ce stage proposera une découverte des différentes disciplines de cirque le matin et l'après-midi sera consacré à une initiation à l'aérien (trapèze, tissu, cerceau). Ce stage n'est pas une spécialisation pour des élèves ayant déjà pratiqué l'aérien. Ils sont néanmoins les bienvenus et des exercices leur seront proposés en fonction de leur niveau. Celui-ci est destiné aux enfants à partir de 6 ans qui désirent découvrir le monde du cirque et des joies de se mettre la tête en bas pour la première fois.",
//   qui: "Pour enfants de 6 à 15 ans",
//   prix: 115,
//   statut: 'confirmed',
//   prix_detail: '- 10% si famille nombreuse ou 2ème enfant inscrit de la même famille',
//   img: "/images/stages/stage_mai.jpg",
//   isCancelled: false
// };

// const JonglerieJuillet2025: IStage = {
//   name: 'Stage 2 juillet 2025',
//   title: 'Stage de rythme et jonglerie',
//   short_title: 'Stage de rythme et jonglerie',
//   date: 'Du 14 au 18 juillet 2025 de 9h00 à 16h00',
//   accroche: "Rejoignez-nous pour une aventure circassienne pleine d'énergie!",
//   texte: "Venez découvrir un univers magique où la créativité, le rythme et la jonglerie se rencontrent pour former une expérience inoubliable. Ce sera l'occasion de découvrir différentes disciplines: L'équilibre, le jeu d'acteur,l’acrobatie, la jonglerie avec ses foulards, ses balles, ses massues et diabolos..., le body clapping... Le rythme sera au centre de nos découvertes et de nos apprentissages.",
//   qui: "De 6 à 15 ans",
//   prix: 115,
//   statut: undefined,
//   prix_detail: '- 10% si famille nombreuse ou 2ème enfant inscrit de la même famille',
//   img: "/images/stages/stage_jonglerie_juillet.png",
//   isCancelled: false
// };

const AcroMai2026: IStage = {
  name: 'Stage 4 Mai 2026',
  title: 'Stage de cirque et acrobatie',
  short_title: 'Stage de cirque et acrobatie',
  date: 'Du 4 au 8 mai 2026 de 9h00 à 16h00',
  accroche: "Entrez dans l'univers magique du cirque et de l'acrobatie !",
  texte: "Offrez à vos enfants une semaine de découverte unique où ils exploreront les diverses disciplines de cirque et s'initieront aux sensations de l'acrobatie. Jonglerie, équilibre, trapèze, mini et grand trampoline ainsi que de nombreuses figures acrobatiques seront au rendez-vous. Une aventure ludique pour développer confiance en soi, créativité et esprit d'équipe. Rejoignez nous pour une expérience qui les fera rêver !",
  qui: "De 6 à 15 ans",
  prix: 115,
  statut: 'confirmed',
  prix_detail: '- 10% si famille nombreuse ou 2ème enfant inscrit de la même famille',
  img: "/images/stages/stage_acro_aout.png",
  isCancelled: false
};

export const Stages: IStage[] = [
  // PluriAerienMai2025,
  // AerienJuillet2025,
  // JonglerieJuillet2025,
  AcroMai2026
];

